import script from "./DeviceForm.vue?vue&type=script&setup=true&lang=js"
export * from "./DeviceForm.vue?vue&type=script&setup=true&lang=js"

import "./DeviceForm.vue?vue&type=style&index=0&id=f23896be&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f23896be"]])

export default __exports__